module.exports = __webpack_public_path__ + "img/顺时针旋转90度3.cab0f0ee.svg";